import { render } from "./NewsLine.vue?vue&type=template&id=44867e54&scoped=true"
import script from "./NewsLine.vue?vue&type=script&lang=js"
export * from "./NewsLine.vue?vue&type=script&lang=js"

import "./NewsLine.vue?vue&type=style&index=0&id=44867e54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44867e54"

export default script